import { canSwitchComputerModel } from '#pplx/frontend/ask-models/canSwitchComputerModel.js';
import { SearchMode, SearchModel } from '#pplx/frontend/ask-models/types/search-modes.js';
const NO_CONTROL = { kind: 'none' };
export function resolveModelPickerControl(inputs) {
    if (inputs.kind === 'mode-model') {
        return inputs.showModelSelector && inputs.isModelSelectionEnabled
            ? { kind: 'dropdown', trackModelSelection: inputs.selectedSearchMode !== SearchMode.ASI }
            : NO_CONTROL;
    }
    const { orchestrator, isModelSelectionEnabled, computerEffortPreferences, supportsModelSwitching, } = inputs;
    // Effort selections route through mode_config. A resolved streaming model's
    // legacy switching capability must not replace that selector with a model chip.
    if (isModelSelectionEnabled &&
        (computerEffortPreferences !== undefined ||
            canSwitchComputerModel(orchestrator, supportsModelSwitching))) {
        return { kind: 'dropdown', trackModelSelection: true };
    }
    return orchestrator === SearchModel.ASI ? NO_CONTROL : { kind: 'chip', model: orchestrator };
}
//# sourceMappingURL=resolveModelPickerControl.js.map